import { FallcoClass }           from '../../../classes/FallcoClass';
import Utilities                 from '../../utilities';
import { template as _template } from 'lodash';

/**
 * Per il funzionamento di questa libreria, si deve aggiungere un DIV alla pagina con ID "templates_container".
 *
 * Dentro poi andranno tutti i template che desiderate usare. Ogni template dovr� avere l'attrivuto "tmpl-name"
 * che conterr� il nome del unico del template, stesso nome che a cui si dovr� fare riferimento quando si vorr�
 * recuperare il template tramite JS.
 *
 * Per usare poi il template, basta chiamare la funzione fallco.templates.get_template("nome_template");
 * Questa funzione ritorner� un elemento jQuery che sar� un clone del template originario. Questo elemento
 * avr� anche un metodo nuovo: "populate(data)".
 * Questo metodo popoler� il template con i dati contenuti nell'object passato, a patto che il template contenga
 * dei campi con il valore ${id_campo}.
 *
 * ES:
 * <div id="templates_container">
 *   <div tmpl-name="inserisci_intermediario">
 *     <strong>${titolo}</strong>
 *   </div>
 * </div>
 *
 * var tmpl = fallco.templates.get_template("inserisci_intermediario");
 * var data = {
 *   titolo = "Il valore che desidero per questo campo"
 * };
 *
 * tmpl.populate(data);
 *
 * A questo punto, l'elemento tmpl, conterr� tutto il codice HTML, con i dati correttamente inseriti.
 *
 * tmpl.html();
 *
 * // Risultato del comando di sopra.
 * <div>
 *   <strong>Il valore che desidero per questo campo</strong>
 * </div>
 *
 */

class Template {
  constructor (tmpl) {
    let requested_template;
    
    if (!tmpl) {
      throw 'Template non trovato: ' + name;
    } else {
      requested_template = tmpl.clone(true);
      requested_template.removeAttr('tmpl-name');
    }
    
    requested_template.originalHtml = requested_template.html;
    requested_template.populate     = data => this.populate_template(data);
    requested_template.html         = () => requested_template.originalHtml().replace(/-tag-escape/g, '');
    
    requested_template.getRequiredFields = () => this.get_required_fields();
    /**
     * @deprecated
     * @return {Array}
     */
    requested_template.get_required_fields = () => this.get_required_fields();
    
    this.template = requested_template;
    
    return requested_template;
  }
  
  /**
   * Ritorna l'elenco dei campi che sono compilabili nel template corrente.
   * Per essere individuati, i campio devono contenere la stringa ${<<nome>>}
   *
   * @return {Array}
   */
  get_required_fields () {
    let tmpl      = this.template;
    let fields    = tmpl[0].outerHTML.match(/\${(.*?)}/g);
    let to_return = [];
    
    if (!fields) {
      return to_return;
    }
    
    fields.map(function (str) {
      to_return.push(str.replace(/\${|}/g, ''));
    });
    
    return to_return;
  }
  
  /**
   * Popola il template con i dati passati come parametro.
   * Per poter popolare i vari campi, questi devono contenere la stringa ${<<nome>>}, la quale verr� sostituita con i dati passati. Questa stringa
   * deve avere lo stesso nome utilizzato come key nell'oggetto passato.
   *
   * @param {Object} data
   */
  populate_template (data) {
    let tmpl        = this.template;
    let tmpl_str    = _template(tmpl[0].outerHTML);
    let tmpl_fields = this.get_required_fields();
    
    // al posto dell'outerHTMl, usare l'original htmlò
    
    if (!tmpl_fields) {
      return;
    }
    
    /*tmpl_fields.map(function (key) {
     let value = data[key];
     let regex = new RegExp("(\\${" + key + "})", "g");
     
     if (!value) {
     value = "";
     }
     
     tmpl_str = tmpl_str.replace(regex, value);
     });*/
    
    tmpl = $(tmpl_str(data));
    
    this.template[0] = tmpl[0];
  }
}

/**
 * Classe che si occupa della gestione dei template.
 * Permette di chiamare ricevere un template in base al suo nome.
 *
 * @constructor
 */
class FallcoTemplates extends FallcoClass {
  constructor () {
    super();
    
    this._templates = {};
    
    this._addRequiredCSS();
    
    window.addEventListener('load', () => this._init());
    
    return super.expose_to_public('templates', this);
  }
  
  _addRequiredCSS () {
    const styleTag = Utilities.create_style_tag('templatesStyle');
    
    styleTag.append_style_class('#templates_container',
      { display: 'none!important' });
  }
  
  /**
   *  Trasforma tutti i template presenti sulla pagina in oggetti jQuery ed elimina il codice HTMl dalla pagina.
   */
  _init (target) {
    let tmpl_container = (!target) ? $('#templates_container') : $(target);
    
    // per ogni entry del container, lo interpreta come singolo template e lo salva in una variabile.
    tmpl_container.children().each((i, element) => {
      let el   = $(element);
      let name = el.attr('tmpl-name');
      
      this._templates[name] = el.clone(true);
    });
    
    //Una volta salvati tutti i template in variabili, elimina il container che li conteneva insieme al suo contenuto.
    tmpl_container.remove();
  }
  
  update (target) {
    this._init(target);
  }
  
  /**
   * Passando il nome del template da caricare, ritorna il jQuery Object del template.
   *
   * @param name : string
   * @return {Template}
   */
  getTemplate (name) {
    let tmpl = this._templates[name];
    
    return new Template(tmpl);
  }
  
  /**
   * @deprecated
   *
   * @param {string} name
   * @return {Template}
   */
  get_template(name){
    return this.getTemplate(name)
  }
  
  /**
   *
   * @param name
   * @param selector
   * @param action_type
   * @param _function
   */
  set_action (name, selector, action_type, _function) {
    this._templates[name].find(selector).on(action_type, _function);
  }
  
  /**
   *
   * @param {string} string
   * @param {data} data
   * @return {string}
   */
  parseTemplateString (string, data) {
    const tmpl = _template(string);
    
    return tmpl(data);
  }
}

export default new FallcoTemplates();
